import { IContactDetails } from '@models/backend/contacts';

type ResponsibilityId =
    | 'head-of-city'
    | 'head-of-area'
    | 'property-manager'
    | 'lettings-manager'
    | 'senior-lettings-manager'
    | 'construction-manager'
    | 'facilities-manager'
    | 'accounting-manager'
    | 'deposit-manager'
    | 'apartment-inspection'
    | 'claim-manager'
    | 'operational-cost'
    | 'operational-cost-group'
    | 'service-center-agent'
    | 'admin';

export const AuthorizedResponsibilities: ResponsibilityId[] = ['admin', 'senior-lettings-manager', 'head-of-area'];

export interface IRotationTeaserFilter {
    region?: string;
    costCenterCode?: string;
}
export interface IRefreshAssignmentsData {
    costCenterCode: string[];
    selectedLm: IContactDetails;
}
